import { render, staticRenderFns } from "./ExtraFieldGroups.vue?vue&type=template&id=1421047f&lang=pug"
import script from "./ExtraFieldGroups.vue?vue&type=script&lang=js"
export * from "./ExtraFieldGroups.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports